import { ILogger } from 'js-logger';

import { WsCallsApiNetworkService } from '@gem/call/WsApi/wsCallsApi/WsCallsApiNetworkService';
import { CallWsRequest, CallWsResponse } from '@gem/call/WsApi/wsCallsApi/types/call_websocket_pb';
import { logger } from '@gem/modules/logger';
import { WsNetworkError } from '@gem/modules/wsClient/wsErrors';
import { NetworkEventType } from '@gem/modules/wsClient/wsServices';

interface WsEventMessage {
  id: string;
  message: CallWsResponse | CallWsRequest;
}

export class WsCallsLog {
  private workspace = 'WsCalls';
  private unsubscribes: Array<() => void>;

  constructor(private wsNetworkService: WsCallsApiNetworkService) {
    this.init();
  }

  get logWorkspace(): ILogger {
    return logger.get(this.workspace);
  }

  public init(): void {
    const networkServiceUnsubscribe = this.wsNetworkService.onWsLog(
      ({ message }: WsEventMessage) => {
        if (message.type.case === 'request') {
          this.logWorkspace.log(
            `%c${message.type.value.type.case}%c -> Request`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #bf912c',
            message.type.value.requestId,
            message.type.value.type.value
          );
          return;
        }

        if (message.type.case === 'event') {
          this.logWorkspace.log(
            `%c${message.type.value.event.case}%c Realtime event`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #a04ac2',
            message.type.value.event.value
          );
          return;
        }

        if (message.type.case === 'response') {
          this.logWorkspace.log(
            `%c${message.type.value.type.case}%c <- Response`,
            'color: #5698d6; font-size: 1em; font-weight: bold;',
            'color: #30964b',
            message.type.value.requestId,
            message.type.value.type.value?.type
          );
          return;
        }
      }
    );

    const wsNetworkErrorUnsubscribe = this.wsNetworkService.on(
      NetworkEventType.NetworkError,
      (error: WsNetworkError) => {
        this.logWorkspace.log(
          `%cNetworkError ${error.code}:`,
          'color: #a83b3d; font-size: 1em; font-weight: bold;',
          error.message
        );
      }
    );

    const wsNetworkOpenUnsubscribe = this.wsNetworkService.on(NetworkEventType.Open, () => {
      this.logWorkspace.log(`%cSocket Open`, 'color: #99ab3e; font-size: 1em; font-weight: bold;');
    });

    this.unsubscribes = [
      networkServiceUnsubscribe,
      wsNetworkErrorUnsubscribe,
      wsNetworkOpenUnsubscribe,
    ];
  }

  public detach(): void {
    this.unsubscribes.forEach((unsubscribe) => {
      unsubscribe();
    });
    this.unsubscribes = [];
  }
}
